// extracted by mini-css-extract-plugin
module.exports = {"badge":"timeline-module--badge--10X9G","iconHolder":"timeline-module--icon-holder--3N-Rg","iconLink":"timeline-module--icon-link--1lHMR"};